require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-redefines-member-loyalty-with-innovative-rewards-program.json") })
        }
      }, "path---articles-financial-center-redefines-member-loyalty-with-innovative-rewards-program");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-redefines-member-loyalty-with-innovative-rewards-program!./.cache/json/articles-financial-center-redefines-member-loyalty-with-innovative-rewards-program.json
// module id = 1662
// module chunks = 231608221292675